import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { CancelButton, FormButton } from '../../../../../components/Button';
import { FormFieldset, Input } from '../../../../../components/Form';
import Loader from '../../../../../components/Loader';
import { ILeaveRequest } from '../../Leave.props';
import useAddLeaveRequest from './useAddLeaveRequest';

const AddLeaveRequest: React.FC = () => {
  const {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handleCancel,
    handleTypeChange,
    handleDateChange,
  } = useAddLeaveRequest();

  const { handleSubmit: useFormSubmit } = useForm<ILeaveRequest>();

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">
            Add Leave Request
          </h1>
        </div>
        
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        ><div>
        <p className="text-base text-fontBlack ml-5">
          -If you're taking a full-day leave on Friday and Monday, please
          update your leave in two parts:
        </p>
        <p className="text-sm text-red-400 ml-5">
          1. Apply for leave on Friday and Saturday 2. Apply separately for
          leave on Monday
        </p>
        <p className="text-base text-fontBlack ml-5">
          -If you're taking a half-day leave on Friday (post-lunch) and a
          full-day leave on Monday, please update your leave request in two
          parts:
        </p>
        <p className="text-sm text-red-400 ml-5">
          1. Apply for leave on Friday (half-day post-lunch) and Saturday 2.
          Apply separately for leave on Monday (full day)
        </p>
        <p className="text-base text-fontBlack ml-5">
          -If you're taking a full-day leave on Friday and a half-day leave on
          Monday (before lunch), please update your leave in two parts:
        </p>
        <p className="text-sm text-red-400 ml-5">
          1. Apply for leave on Friday and Saturday 2. Apply separately for a
          half-day leave on Monday (pre-lunch)
        </p>
        <p className="text-base bg-red-400 text-white ml-5 px-1 w-fit font-bold">
        If you not follow the leave the rules then we do not have but it will affect in bonus and increment
        </p>
      </div>
          <FormFieldset Ftitle="Leave Details">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              <div className="flex flex-col">
                <label className="mb-2 text-sm font-medium text-gray-700">
                  Leave Type
                </label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleTypeChange}
                  className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                >
                  <option value="">Select Type</option>
                  <option value="single">Single Day</option>
                  <option value="multiple">Multiple Days</option>
                </select>
              </div>

              {formData.type === "single" && (
                <div className="flex flex-col">
                  <label className="mb-2 text-sm font-medium text-gray-700">
                    Sub Type
                  </label>
                  <select
                    name="subtype"
                    value={formData.subtype}
                    onChange={handleChange}
                    className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  >
                    <option value="">Select Sub Type</option>
                    <option value="full">Full Day</option>
                    <option value="half">Half Day</option>
                  </select>
                </div>
              )}

              {formData.type === "single" ? (
                <div className="flex flex-col">
                  <label className="mb-2 text-sm font-medium text-gray-700">
                    Date
                  </label>
                  <input
                    type="date"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleDateChange}
                    min={
                      new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                        .toISOString()
                        .split("T")[0]
                    }
                    className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>
              ) : (
                <>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm font-medium text-gray-700">
                      From Date
                    </label>
                    <input
                      type="date"
                      name="fromDate"
                      value={formData.fromDate}
                      onChange={handleDateChange}
                      min={
                        new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                          .toISOString()
                          .split("T")[0]
                      }
                      className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                      required
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm font-medium text-gray-700">
                      To Date
                    </label>
                    <input
                      type="date"
                      name="toDate"
                      value={formData.toDate}
                      onChange={handleDateChange}
                      min={formData.fromDate}
                      className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                      required
                    />
                  </div>
                </>
              )}

              <div className="flex flex-col md:col-span-2">
                <label className="mb-2 text-sm font-medium text-gray-700">
                  Description
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary h-32"
                  required
                />
              </div>
            </div>
          </FormFieldset>

          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              type="submit"
              children="Submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLeaveRequest;
